import React, { createContext, useState } from "react";
import { toast } from "react-toastify";
import useFetch from "./useFetch";
import { useUserData } from "./UserDataContext";

const SettingContext = createContext();

const SettingProvider = (props) => {
  const { userData } = useUserData();
  const [showNumSix, setShowNumSix] = useState(userData.setting.show_num_six);
  const [defaultRingSize, setDefaultRingSize] = useState(4);
  const [reverseShowNums, setReverseShowNums] = useState(
    userData.setting.reverse
  );

  const [patchData, setPatchData] = useState([]);

  const ringHeadersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
    { colName: "code_one", name: "تعداد یک" },
    { colName: "code_two", name: "تعداد دو" },
    { colName: "code_three", name: "تعداد سه" },
    { colName: "code_four", name: "تعداد چهار" },
    { colName: "code_five", name: "تعداد پنج" },
    { colName: "details", name: "جزییات" },
  ];
  const ltrRingHeadersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
    { colName: "code_five", name: "تعداد پنج" },
    { colName: "code_four", name: "تعداد چهار" },
    { colName: "code_three", name: "تعداد سه" },
    { colName: "code_two", name: "تعداد دو" },
    { colName: "code_one", name: "تعداد یک" },
    { colName: "details", name: "جزییات" },
  ];
  const ringHeadersListWithNumSix = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
    { colName: "code_one", name: "تعداد یک" },
    { colName: "code_two", name: "تعداد دو" },
    { colName: "code_three", name: "تعداد سه" },
    { colName: "code_four", name: "تعداد چهار" },
    { colName: "code_five", name: "تعداد پنج" },
    { colName: "code_six", name: "تعداد شش" },
    { colName: "details", name: "جزییات" },
  ];
  const ltrRingHeadersListWithNumSix = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    { colName: "created_at", name: "تاریخ ثبت‌سفارش" },
    { colName: "code_six", name: "تعداد شش" },

    { colName: "code_five", name: "تعداد پنج" },

    { colName: "code_four", name: "تعداد چهار" },

    { colName: "code_three", name: "تعداد سه" },

    { colName: "code_two", name: "تعداد دو" },

    { colName: "code_one", name: "تعداد یک" },
    { colName: "details", name: "جزییات" },
  ];
  const ringTableItems = () => {
    if (showNumSix) {
      if (reverseShowNums) {
        return ltrRingHeadersListWithNumSix;
      }
      return ringHeadersListWithNumSix;
    } else {
      if (reverseShowNums) {
        return ltrRingHeadersList;
      }
      return ringHeadersList;
    }
  };

  const ringDataKey = [
    "code",
    "show_name",
    "gender",
    "color",
    "created_at",
    "size_one_num",
    "size_two_num",
    "size_three_num",
    "size_four_num",
    "size_five_num",
  ];
  const ringDataKeyWithNumSix = [
    "code",
    "show_name",
    "gender",
    "color",
    "created_at",
    "size_one_num",
    "size_two_num",
    "size_three_num",
    "size_four_num",
    "size_five_num",
    "size_six_num",
  ];
  const ringTableItemsDataKey = () => {
    if (showNumSix) {
      return ringDataKeyWithNumSix;
    } else return ringDataKey;
  };

  const onchange_showNumSix = (data) => {
    if (data) {
      setDefaultRingSize(5);
    } else {
      setDefaultRingSize(4);
    }
    setShowNumSix(data);
    setPatchData({ show_num_six: data });
    updateUserDataApi.reFetch();
  };

  const onchange_reverseShowNums = (data) => {
    setReverseShowNums(data);
    setPatchData({ reverse: data });
    updateUserDataApi.reFetch();
  };

  const updateUserDataApi = useFetch({
    method: "patch",
    url: `UserSetting_Service/${userData.setting.id}`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      //   toast.success("عملیات با موفقیت انجام شد", {
      //     position: toast.POSITION.TOP_CENTER,
      //   });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <SettingContext.Provider
      value={{
        showNumSix,
        defaultRingSize,
        reverseShowNums,
        ringTableItems,
        ringTableItemsDataKey,
        onchange_showNumSix,
        onchange_reverseShowNums,
      }}
      {...props}
    >
      {props.children}
    </SettingContext.Provider>
  );
};

const useSetting = () => React.useContext(SettingContext);

export { SettingProvider, useSetting };
